<script>
  import SelectInput from "@/components/atoms/SelectInput.vue";
  import ButtonIcon from "@/components/atoms/ButtonIcon.vue";
  import ToggleInput from "@/components/atoms/ToggleInput.vue";

  export default {
    name: "CityField",
    components: { SelectInput, ButtonIcon, ToggleInput },
    props: {
      cities: { type: Array, required: true },
      value: { type: Object, default: null },
      enabled: { type: Boolean, default: true },
      inOperation: { type: Boolean, default: true },
      disabled: { type: Boolean, default: false },
      editorOpen: { type: Boolean, default: false },
      editorMode: { type: String, default: null },
    },
    computed: {
      canEdit() {
        return !!(this.value && (this.value._id || this.value.cityName));
      },
      selectValue() {
        if (!this.value) return "";
        return this.value._id || this.value.cityName || "";
      },

      isCreateLocked() {
        return this.editorOpen && this.editorMode === "create";
      },
      isEditLocked() {
        return this.editorOpen && this.editorMode === "edit";
      },

      addBtnClass() {
        return this.isCreateLocked ? "city-field__btn--edit" : "city-field__btn--add";
      },
      editBtnClass() {
        if (!this.canEdit || this.isEditLocked) return "city-field__btn--edit";
        return "city-field__btn--add";
      },

      isAddDisabled() {
        return this.disabled || this.isCreateLocked;
      },
      isEditDisabled() {
        return !this.canEdit || this.disabled || this.isEditLocked;
      },
    },
    methods: {
      onChange(val) {
        this.$emit("select", val);
      },
      onToggleEnable(val) {
        this.$emit("update:enabled", val);
      },
      onToggleOperation(val) {
        this.$emit("update:inOperation", val);
      },
      onAdd() {
        this.$emit("add");
      },
      onEdit() {
        this.$emit("edit");
      },
    },
  };
</script>

<template>
  <div class="city-field">
    <label class="city-field__label">Ciudad</label>

    <div class="city-field__row">
      <SelectInput class="city-field__select" :key="selectValue + '-' + (cities ? cities.length : 0)" :options="cities" :value="selectValue" :disabled="disabled" @input="onChange" />

      <ButtonIcon class="city-field__btn" :class="addBtnClass" icon="fas fa-plus" :disabled="isAddDisabled" @click="onAdd" />
      <ButtonIcon class="city-field__btn" :class="editBtnClass" icon="fas fa-pencil-alt" :disabled="isEditDisabled" @click="onEdit" />
    </div>

    <div v-if="value" class="city-field__toggles">
      <ToggleInput :value="enabled" label="Habilitada" @input="onToggleEnable" :disabled="isAddDisabled" />
      <ToggleInput :value="inOperation" label="En operación" @input="onToggleOperation" :disabled="isAddDisabled" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .city-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    &__label {
      font-family: $newFont_medium;
      font-size: 16px;
      margin-bottom: 4px;
      color: #3d3d3d;
    }

    &__row {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    &__select {
      flex: 1;
    }

    &__btn {
      border-radius: 8px;
      transition: all ease-in 0.2s;
      &--add {
        background: #bd0909;
      }
      &--edit {
        background: #c3c3c3;
      }
    }

    &__toggles {
      margin-top: 8px;
      display: flex;
      gap: 16px;
    }
  }
</style>
